<template>
  <BasePopover
    v-model="isCalendarOpen"
    :placement="popperOptions.placement"
    :padding="popperOptions.padding"
    :popper-class="[popperOptions.class, 'date-range-picker__popper']"
    :is-in-modal="isInModal"
    :close-on-click-reference="closeOnClickReference"
    :close-on-click-outside="closeOnClickOutside"
    offset="0"
  >
    <template slot="reference">
      <slot
        name="input"
        v-bind="{value, large, small, onDateInput: handleManualDateInput}"
      />

      <!-- because slots fallback not working in exported components -->
      <MCalendarInput
        v-if="!$scopedSlots['input']"
        :placeholder="placeholder"
        :value="value"
        :large="large"
        :small="small"
        :min-date="minDate"
        :max-date="maxDate"
        @input="handleManualDateInput"
      />
    </template>
    <template slot="popper">
      <div class="m-calendar-dropdown">
        <Calendar
          :start-date="value"
          :end-date="value"
          :month-date="monthDate"
          :locale="locale"
          :min-date="minDate"
          :max-date="maxDate"
          @nextMonth="nextMonth"
          @prevMonth="prevMonth"
          @dateClick="handleSelectDate"
        />
      </div>
    </template>
  </BasePopover>
</template>

<script>
  import BasePopover from 'components/common/BasePopover';
  import MCalendarInput from 'components/Inputs/Dates/MCalendar/MCalendarInput';
  import Calendar from 'components/Inputs/Dates/common/Calendar';
  import getTr from 'translation';
  import {momentWrapper} from 'components/Inputs/Dates/utils/momentWrapper';
  import _ from 'lodash';

  _.noConflict();

  export default {
    name: 'MCalendar',
    components: {MCalendarInput, BasePopover, Calendar},
    props: {
      value: {
        type: Date,
        default: null
      },
      placeholder: {
        type: String,
        default: ''
      },
      large: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      minDate: {
        type: Date,
        default: null
      },
      maxDate: {
        type: Date,
        default: null
      },

      isInModal: {
        type: Boolean,
        default: false
      },
      popperOptions: {
        type: Object,
        default: () => ({
          padding: '22px 24px 15px',
          placement: 'bottom-start',
          class: null
        })
      },

      // close dropdown calendar by clicking outside this dropdown
      closeOnClickOutside: {
        type: Boolean,
        default: true
      },

      // reference it's the input field with dates
      closeOnClickReference: {
        type: Boolean,
        default: true
      },

      calendarInputComponent: {
        type: Object,
        default: () => MCalendarInput
      }
    },
    data () {
      return {
        isCalendarOpen: false,

        locale: {

          // default locale
          direction: 'ltr',
          format: 'DD.MM.YY',
          inputFormat: 'DD.MM.YY',
          delimiter: '.',
          separator: '-',
          applyLabel: 'OK',
          cancelLabel: getTr('cancel'),
          clearLabel: getTr('reset'),
          weekLabel: 'W',
          customRangeLabel: 'Custom Range',
          daysOfWeek: this.getWeekdays(),
          firstDay: momentWrapper().firstDayOfWeek(),
          ...this.localeData
        },

        // use date from value or current date
        monthDate: this.getMonthForDate(this.value || new Date())
      };
    },
    watch: {
      value () {
        // update calendar month if date is changed
        if (this.value) {
          this.monthDate = this.getMonthForDate(this.value);
        }
      }
    },
    methods: {
      getWeekdays () {
        return _.range(7).map(day => momentWrapper().lang().
          weekdaysMin(momentWrapper().day(day % 7), 'nominative'));
      },
      getMonthForDate (date) {
        return new Date(date.getFullYear(), date.getMonth(), 1);
      },
      handleManualDateInput (val) {
        this.$emit('input', val);
        this.monthDate = this.getMonthForDate(val);
      },
      nextMonth () {
        this.monthDate = new Date(this.monthDate.getFullYear(), this.monthDate.getMonth() + 1, 1);
      },
      prevMonth () {
        this.monthDate = new Date(this.monthDate.getFullYear(), this.monthDate.getMonth() - 1, 1);
      },
      handleSelectDate (val) {
        // convert moment to Date object
        this.$emit('input', val.toDate());
        this.closePicker();
      },
      closePicker () {
        this.isCalendarOpen = false;
      }
    }
  };
</script>

<style>
  .m-calendar-dropdown {
    padding: 20px;
  }

</style>
